//  @ts-check
import { useCallback } from 'react';
import { SMALL_NAV_TOASTER_ID } from '../tools/constants';

/**
 * Returns handlers to adjust mobile nav toaster.
 * @param {Object} [props] - Object of props for the hook
 * @param {String} [props.brandFamily=''] - Current brand family
 * @param {Boolean} [props.hasRefreshedNav=false] - Switch value for refreshed nav
 * @param {Element|null} [props.navBarElement=null] - Navbar element from ref
 * @returns {{ onUnmount: Function, onOpen: Function }} - Toaster handlers
 */
const useUpdateToasterPosition = (props = {
  brandFamily: '',
  hasRefreshedNav: false,
  navBarElement: null,
}) => {
  const {
    brandFamily,
    hasRefreshedNav,
    navBarElement,
  } = props;

  const onOpen = useCallback(() => {
    if (!hasRefreshedNav) return;
    if (navBarElement && brandFamily !== 'hol') {
      const newTopToasterPosition = navBarElement.getBoundingClientRect().top <= 0
        ? 0
        : navBarElement.getBoundingClientRect().top + window.scrollY;
      if (newTopToasterPosition) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      // we need to set the position to the specific div of the modal that has the position fixed
      document.getElementById(SMALL_NAV_TOASTER_ID).style.top = `${newTopToasterPosition}px`;
    }
    // removing the overflow hidden to make the header be visible in the background
    document.body.style.overflow = 'visible';
  }, [navBarElement, hasRefreshedNav, brandFamily]);

  const onUnmount = useCallback(() => {
    if (hasRefreshedNav) {
      // removing the overflow extra style on toaster closure to make sure
      // other toasters across the site work as expected
      document.body.style.overflow = '';
    }
  }, [hasRefreshedNav]);

  return { onUnmount, onOpen };
};

export default useUpdateToasterPosition;
